(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ContactLookup', ContactLookup);

  ContactLookup.$inject = ['$resource', 'API_URI'];

  function ContactLookup($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_lookup/contacts';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
